export default __webpack_public_path__ + "images/M1.0777769.png";